import { bankDetails } from './reducers';
export default bankDetails;
